"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var NotificationBadge = function (_a) {
    var _b = _a.show, show = _b === void 0 ? false : _b;
    if (!show) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
            position: 'absolute',
            top: 0,
            right: 0,
            borderRadius: '50%',
            height: '10px',
            width: '10px',
            backgroundColor: 'primary.main',
        } }));
};
exports.default = NotificationBadge;
